import { useEffect, useState } from 'react';

// side-panel blocks hidden per branch (mode id); "show all fields" in settings brings them back
const KEY = 'giss_show_all_fields';
const LEAK = ['materials', 'inventory'];
const HIDE = {
  aqua: ['dayRoute', 'projAddr', 'repAddr', 'done', 'times', 'crew', 'jobNav', 'materials', 'signature', 'timesheet', 'inventory', 'daily', 'prices'],
  storm: ['dayRoute', 'projAddr', 'repAddr', 'done', 'times', 'crew', 'jobNav', 'materials', 'signature', 'timesheet', 'inventory', 'daily', 'prices'],
  detect_water: LEAK,
  detect_gas: LEAK,
  detect_cable: LEAK,
  detect_locate: LEAK,
  detect_sewer: LEAK,
  garden: ['roadPrefetch', 'inventory'],
  building: ['roadPrefetch'],
  photo: ['roadPrefetch'],
};
export const showAllFields = () => localStorage.getItem(KEY) === '1';
export const setShowAllFields = (on) => { localStorage.setItem(KEY, on ? '1' : '0'); window.dispatchEvent(new Event('giss-fields')); };
export function usePanel(mode) {
  const [all, setAll] = useState(showAllFields);
  useEffect(() => { const f = () => setAll(showAllFields()); window.addEventListener('giss-fields', f); return () => window.removeEventListener('giss-fields', f); }, []);
  return (k) => all || !(HIDE[mode] || []).includes(k);
}
export const FIELDS_TXT = {
  de: ['Alle Felder zeigen', 'Blendet auch Felder ein, die in deiner Branche normalerweise ausgeblendet sind (z. B. Zeiten, Mitarbeiter, Routen in AquaFlow).'],
  en: ['Show all fields', 'Also shows fields that are normally hidden in your branch (e.g. times, staff, routes in AquaFlow).'],
  it: ['Mostra tutti i campi', 'Mostra anche i campi normalmente nascosti nel tuo settore (es. orari, personale, percorsi in AquaFlow).'],
  es: ['Mostrar todos los campos', 'Muestra también los campos que normalmente están ocultos en tu sector (p. ej. horas, personal, rutas en AquaFlow).'],
  pt: ['Mostrar todos os campos', 'Mostra também campos normalmente ocultos no seu setor (p. ex. horários, equipa, rotas no AquaFlow).'],
  fr: ['Afficher tous les champs', 'Affiche aussi les champs normalement masqués dans votre métier (p. ex. heures, personnel, itinéraires dans AquaFlow).'],
  sq: ['Shfaq të gjitha fushat', 'Shfaq edhe fushat që zakonisht fshihen në degën tuaj (p.sh. oraret, stafi, rrugët në AquaFlow).'],
};
